
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CouponInterface } from '@/types/coupons';

@Component({
    components: {},
})
export default class PaymentMethodCard extends Vue {
    @Prop({ required: true })
    coupon!: CouponInterface;

    @Prop({ required: true })
    onRemove!: () => void;

    remove() {
        this.onRemove();
    }
}
